<template>
  <div id="blog-container">
    <preloader v-if="loading" />
    <div v-else>
      <article
        v-for="(post, i) in posts"
        :key="`r${i}`"
        :id="`post-`"
        class="seasidetms_archive_type post-21709 product type-product status-publish has-post-thumbnail product_cat-apple-watch-series-5 product_cat-apple-watch pa_color-space-gray pa_color-belt-black pa_model-apple-watch-series-5 pa_new-or-used-used pa_size-apple-watch-44mm first instock shipping-taxable purchasable product-type-simple"
      >
        <div class="seasidetms_archive_item_img_wrap">
          <figure class="seasidetms_img_wrap">
            <a
              href="#"
              class="seasidetms_img_link preloader"
              :title="postTitle(post)"
            >
              <img
                loading="lazy"
                width="300"
                height="300"
                class="full-width wp-post-image lazyloaded"
                :src="postImgSrc(post)"
                :alt="postTitle(post)"
                :title="postTitle(post)"
              />
            </a>
          </figure>
        </div>
        <div class="seasidetms_archive_item_cont_wrap">
          <header class="seasidetms_archive_item_header entry-header">
            <div class="h2 seasidetms_archive_item_title entry-title">
              <router-link
                :to="
                  lang
                    ? '/' + lang + '/blog/' + post.slug
                    : '/blog/' + post.slug
                "
              >
                {{ postTitle(post) }}
              </router-link>
            </div>
          </header>
          <div class="seasidetms_archive_item_content entry-content">
            <p>{{ postDescription(post) }}</p>
          </div>
        </div>
      </article>
      <BlogPagination :total="total" :key="paginationKey" :event="onPage" />
    </div>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader'
import { mapActions, mapState, mapMutations } from 'vuex'
import BlogPagination from '@/components/blog/BlogPagination'

export default {
  name: 'BlogIndex',
  components: { Preloader, BlogPagination },
  data() {
    return {
      loading: true,
      lang: '',
      paginationKey: 'pgKey',
      total: 0,
      title: '',
      description: '',
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          content: this.description,
        },
      ],
    }
  },
  computed: {
    ...mapState(['headline']),
    posts() {
      if (
        Array.isArray(this.$store.state.blog.posts) &&
        this.$store.state.blog.posts.length
      ) {
        console.log(this.$store.state.blog.posts.length)
        return this.$store.state.blog.posts
        // .map(v => this.$h.stripHTML(v.description))
      } else {
        return []
      }
    },
  },
  created() {
    if (
      !(
        Array.isArray(this.$store.state.blog.posts) &&
        this.$store.state.blog.posts.length
      ) ||
      (Array.isArray(this.$store.state.blog.posts) &&
        this.$store.state.blog.posts.length === 1)
    ) {
      this.$store
        .dispatch('fetchBlog')
        .then(() => {
          this.total = this.$store.state.blog.posts.total
          this.loading = false
        })
        .catch((err) => {
          console.log('*err', err)
        })
    } else {
      this.total = this.$store.state.blog.posts.total
      this.loading = false
    }
  },
  beforeMount() {
    // this.total = this.$store.state.blog.posts.total
    this.$store.dispatch('setHeadline', this.$t('mainMenu.blog'))
    this.$store.dispatch('setBreadcrumbs', [{ name: this.$t('mainMenu.blog') }])

    this.lang = this.$store.getters.lang
  },
  mounted() {
    this.title = this.$t('meta.blog.titleTmpl', {
      h1: this.headline,
    })
    this.description = this.$t('meta.blog.descriptionTmpl', {
      h1: this.headline,
    })
    this.initPagination()
  },
  methods: {
    onPage() {
      this.loading = true
      function composePath(...args) {
        let path = ''
        for (let arg of args) {
          path += arg
        }
        return path
      }

      let path = composePath(
        '/posts/',
        `?page=${this.$store.state.blog.page}`,
        `&limit=${this.$store.state.blog.perPage}`
      )
      this.fetchBlogPagination(path).then(() => {
        this.loading = false
        this.useMeta()
      })
      // console.log('*PATH', path)
    },
    useMeta() {
      if (this.$store.state.blog.page > 1) {
        this.title = this.$t('paginationTitle', {
          title: this.headline,
          page: this.$store.state.blog.page,
        })
        this.description = this.$t('paginationDescription', {
          description: this.$t('meta.blog.descriptionTmpl', {
            h1: this.headline,
          }),
          page: this.$store.state.blog.page,
        })
      } else {
        this.title = this.$t('meta.blog.titleTmpl', {
          h1: this.headline,
        })
        this.description = this.$t('meta.blog.descriptionTmpl', {
          h1: this.headline,
        })
      }
    },
    postTitle(post) {
      return post[`name_${this.$i18n.locale}`]
        ? post[`name_${this.$i18n.locale}`]
        : post.title || ''
    },
    postDescription(post) {
      return post[`short_description_${this.$i18n.locale}`]
        ? post[`short_description_${this.$i18n.locale}`]
        : post.title || ''
    },
    postImgSrc(post) {
      return post.photo ? `/img${post.photo}` : 'data:,'
    },
    updatePostsList() {
      this.paginationKey = `pg${Math.random()}`
      this.loading = false
    },
    ...mapActions(['fetchBlogPagination']),
    ...mapMutations(['setPostPage', 'setPostPerPage']),
    initPagination() {
      const queryKey = this.$route.query.page

      if (queryKey == 1 || queryKey == 0) {
        this.$router.push({ path: this.$route.path, query: {} })
      } else if (queryKey) {
        this.setPostPage(Number(queryKey))
        this.setPostPerPage('10')
        this.onPage()
      }
      this.useMeta()
    },
  },
  updated() {
    // this.updatePostsList()
    this.lang = this.$store.getters.lang
  },
}
</script>

<style></style>
